import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useInvoice} from '../hooks/useInvoice';
import {useInvoicesSelection} from '../hooks/useInvoicesSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {IndexPage as InvoiceItemsPage} from '../../invoice-items/pages/IndexPage.tsx'

export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: component,
        loading,
        updateRecord,
    } = useInvoice(componentId);

    const {handleClearSelection} = useInvoicesSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
    }, []);


    if (loading || !component) {
        return <PlatformLoader message='Loading application...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={component.id}
            pageNavigation={<EditPageNavigation component={component}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile
                        record={component}
                    />
                    <InvoiceItemsPage/>
                </Stack>
                :
                <RecordForm
                    record={component}
                    handleSubmit={updateRecord}
                />}


        </FormPageLayout>
    );
};